// extracted by mini-css-extract-plugin
export default {"loading":"TournamentApplicationsModal_loading__DgUgx"};